import logo from '../assets/images/AgriPuente Logo.png';

export const getLogoUrl = () => {
  try {
    // Corrected path: remove extra 'src/'
    return new URL('../assets/images/AgriPuente Logo.png', import.meta.url).href;
  } catch (e) {
    console.warn('Fallback to direct import for logo:', e);
    return logo;
  }
};
